import {HubriseOrderConverterContract} from 'common/api/hubrise/service/HubriseOrderConverterContract';
import {HubriseOrderItemContract} from 'common/api/hubrise/model/order/HubriseOrderItemContract';
import {HubriseOrderEditableItemContract} from 'common/api/hubrise/model/order/HubriseOrderEditableItemContract';
import {HubriseOrderOptionContract} from 'common/api/hubrise/model/order/HubriseOrderOptionContract';
import {HubriseServiceType} from 'common/api/hubrise/model/order/HubriseServiceType';
import {ObjectUtil} from 'common/util/ObjectUtil';

export class HubriseOrderConverter implements HubriseOrderConverterContract {
    public items(editableItems: HubriseOrderEditableItemContract[], serviceType: HubriseServiceType): HubriseOrderItemContract[] {
        if (!Array.isArray(editableItems)) {
            return [];
        }

        return editableItems.map((editableItem: HubriseOrderEditableItemContract) => {
            const options: HubriseOrderOptionContract[] = [];
            if (Array.isArray(editableItem.options)) {
                editableItem.options.forEach((editableOption: HubriseOrderOptionContract) => {
                    options.push({
                        ref: editableOption.ref,
                        option_list_name: editableOption.option_list_name,
                        name: editableOption.name,
                        quantity: Number(editableOption.quantity ?? 1),
                        price: editableOption.price
                    });
                });
            }

            return ObjectUtil.compact({
                sku_ref: editableItem.sku_ref,
                sku_name: editableItem.sku_name,
                product_name: editableItem.product_name,
                quantity: String(editableItem.quantity ?? '1'),
                price: editableItem.price,
                subtotal: '', // TODO multiply quantity + sum options
                tax_rate: serviceType === undefined || editableItem.tax_rate === undefined || editableItem.tax_rate === null ? undefined : editableItem.tax_rate[serviceType],
                customer_notes: editableItem.customer_notes,
                options: options
            });
        });
    }
}
